import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['6 kötet', '5 bónusz', '240 oldal', '1–8. osztály'];
const reassurances = ['Azonnali letöltés', 'Nyomtatható PDF-fájlok', '7 napos elégedettségi garancia'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15bsmth3jo8k3">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbtwnm1seqbp" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ebxu7r8qn6y9">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1myvwg1ht3a">
          A rajzóráid már <em className="text-red-700" data-id="element-118" data-mp="1o4n1e9x99yns">ma készen lehetnek.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="224eco2we10y3">
          Ahelyett, hogy ötleteket keresgélnél, minden feladatlapot magad készítenél, és a vasárnap estéidet óravázlatokkal töltenéd, egy rendszerezett rajzcsomagod lesz az egész tanévre. Több idő arra, ami igazán számít:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s4xpriyzbnn5">
          A gyerekek. A tanításod. Az életed az iskolán kívül.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="123mxiix5vrpo">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="162dwywp3nlfy">{item}</li>)}
        </ul>

        <p className="mt-8 whitespace-nowrap font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b2rydvw73x50">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1fv1szp899ldm">Egyszeri fizetés – nincs előfizetés.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1kstm2mkmzdje">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1pszggaiaje56" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1pqczxldf9oat">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3qufdtpskrks5">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3qskv8i4s04r8" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}